module.exports = __webpack_public_path__ + "static/img/company.fad469f1.png";